import styled from "styled-components";

export const UploadContainer = styled.div`
  margin-bottom: 16px;
  padding: 20px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 518px;
`;

export const FileDetails = styled.div`
  margin-top: 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;

export const FileImage = styled.img`
  width: 100%;
  max-width: 200px;
  margin-top: 10px;
`;

export const FilePreview = styled.iframe`
  width: 100%;
  height: 400px;
  border: none;
  margin-top: 10px;
`;